import React from 'react'
export const Context = React.createContext<{ trikoId: any }>({ trikoId: 0 })
